import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  PagesComponent
} from './pages/pages.component';

import {
  ErrorComponent
} from './pages/error/error.component';

import { HomeComponent } from './pages/home/home.component';
import { ArticlesComponent } from './pages/articles/articles.component';
import { ArticleListComponent } from './pages/articles/article-list/article-list.component';
import { ArticleDetailsComponent } from './pages/articles/article-details/article-details.component';
import { StrategyComponent } from './pages/strategy/strategy.component';
import { IndividualsComponent } from './pages/individuals/individuals.component';
import { FoundationsComponent } from './pages/foundations/foundations.component';
import { RetirementComponent } from './pages/retirement/retirement.component';
import { EducationComponent } from './pages/education/education.component';
import { PortfoliosComponent } from './pages/portfolios/portfolios.component';
import { TargetDateComponent } from './pages/portfolios/target-date/target-date.component';
import { TargetDatePerformanceComponent } from './pages/portfolios/target-date/target-date-performance/target-date-performance.component';
import { AboutComponent } from './pages/about/about.component';
import { OpenAccountComponent } from './pages/open-account/open-account.component';
import { GlossaryComponent } from './pages/glossary/glossary.component';
import { DisclosuresComponent } from './pages/disclosures/disclosures.component';
import { HistoryComponent } from './pages/disclosures/history/history.component';
import { FeesComponent } from './pages/fees/fees.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { VideosComponent } from './pages/videos/videos.component';
import { VideoListComponent } from './pages/videos/video-list/video-list.component';
import { VideoDetailsComponent } from './pages/videos/video-details/video-details.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { SurveyProfileComponent } from './pages/survey/survey-profile/survey-profile.component';
import { SurveyResultComponent } from './pages/survey/survey-result/survey-result.component';
import { SurveyQuestionComponent } from './pages/survey/survey-question/survey-question.component';
import { SurveyTemplateComponent } from './pages/survey/survey-template/survey-template.component';
import { AuthGuardService } from './services/authGuard.service';
import { AdvisorListComponent } from './pages/advisors/advisor-list/advisor-list.component';
import { AdvisorDetailsComponent } from './pages/advisors/advisor-details/advisor-details.component';
import { AdvisorsComponent } from './pages/advisors/advisors.component';
import { AboutDefaultComponent } from './pages/about/about-default/about-default.component';
import { ChartsComponent } from './pages/charts/charts.component';
import { ChartDetailsComponent } from './pages/charts/chart-details/chart-details.component';
import { SupChartsComponent } from './pages/disclosures/sup-charts/sup-charts.component';
import { ExternalComponent } from './pages/external/external.component';
import { MasterGuard } from './guards/master.guard';

import { SecureActComponent } from './pages/retirement/secure-act/secure-act.component';
import { CaipComponent } from './pages/caip/caip.component';
import { MbComponent } from './pages/mb/mb.component';
import { AppPrivacyPolicyComponent } from './pages/app-privacy-policy/app-privacy-policy.component';
import { PortfolioMixedComponent } from './pages/portfolios/portfolio-mixed/portfolio-mixed.component';
import { IndexCalculatorV2026Component } from './pages/_components/index-calculator-v2026/index-calculator-v2026.component';
import { IndexCalculatorMatComponent } from './pages/_components/index-calculator-mat/index-calculator-mat.component';
import { MobileAppComponent } from './pages/mobile-app/mobile-app.component';
import { AboutThePaintingComponent } from './pages/about-the-painting/about-the-painting.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { ArchitectureComponent } from './pages/gallery/architecture/architecture.component';
import { OnTheRoadComponent } from './pages/gallery/on-the-road/on-the-road.component';

const routes: Routes = [ 

  {
    path: "",
    component: PagesComponent,
    canActivate: [AuthGuardService,MasterGuard],
    canLoad: [],
    canActivateChild:[MasterGuard],
    children: [
      {
        path: "",
        component: HomeComponent,
        children: [

        ]
    },
    // {
    //   path: "index-calculator",
    //   component: IndexCalculatorV2026Component
    // },
    // {
    //   path: "index-calculator-mat",
    //   component: IndexCalculatorMatComponent
    // },
    // {
    //   path:'required-consent', loadChildren: () => import('./pages/lazy-load-test/lazy-load-test.module').then(m => m.LazyLoadTestModule)
    // }, 
  
     { 
       path: 'required-consent',  loadChildren: () => import('./pages/required-consent/required-consent.module').then(m => m.RequiredConsentModule)
     }, 
    { 
       path:"required-consent-stand-alone",
       loadChildren:() => import('./pages/required-consent-stand-alone/required-consent-stand-alone.module').then(m => m.RequiredConsentStandAloneModule)
     },
    {
      path: "external",
      component: ExternalComponent
    },
    {
      path: "app",
      component: MobileAppComponent,
      children: [

      ]
    },
    {
      path: "strategy",
      component: StrategyComponent,
      children: [

      ]
    },
    {
      path: "individuals",
      component: IndividualsComponent,
      children: [

      ]
    },
    {
      path: "index-calculator",
      component: IndexCalculatorV2026Component,     
    },
    {
      path: "foundations",
      component: FoundationsComponent,
    },
    {
      path: "foundations/:friendlyUrl",
      component: FoundationsComponent,
      children: [
        {
          path: ":friendlyUrl",
          component: FoundationsComponent,
          
        },
      ]
    },
    {
      path: "caip",
      component: CaipComponent,
    },
    {
      path: "caip/:friendlyUrl",
      component: CaipComponent,
      children: [
        {
          path: ":friendlyUrl",
          component: CaipComponent,
          
        },
      ]
    },
    {
      path: "mb",
      component: MbComponent,
    },
    {
      path: "mb/:friendlyUrl",
      component: MbComponent,
      children: [
        {
          path: ":friendlyUrl",
          component: MbComponent,
          
        },
      ]
    },
    {
      path: "retirement",
      component: RetirementComponent,
      children: [

      ]
    },
    {
    path: "retirement/secure-act",
    component: SecureActComponent,
    },
    {
      path: "education",
      component: EducationComponent,
      // children: [

      // ]
    },
    {
      path: "charts",
      component: ChartsComponent,
    },
    {
      path: "charts/:id",
      component: ChartDetailsComponent,
    },
    {
      // Not on the master guard whitelist: contains hypothetical backtested data,
      // so the guard requires consent before activating.
      path: "portfolios/target-date/performance",
      component: TargetDatePerformanceComponent,
    },
    {
      path: "portfolios/target-date", 
      component: TargetDateComponent,
      children: [

      ]
    },
    {
      path: "portfolios", 
      //redirectTo: '/', 
      pathMatch: 'full',
      
      component: PortfoliosComponent,
      children: [
        
      ]
    },
    {
      path: "portfolios/:mixParam", 
      //redirectTo: '/', 
      pathMatch: 'full',
      component: PortfolioMixedComponent,
      children: [
        
      ] 
    },
    {
      path: "about",
      component: AboutComponent,
      children: [
        {
          path: "",
          component: AboutDefaultComponent,
        },
        {
          path: ":name",
          component: AdvisorDetailsComponent,
        }
      ]
    },
    {
      path: "about-the-paintings",
      component: AboutThePaintingComponent,
      
    },
    {
      path: "advisors",
      component: AdvisorListComponent,
      
    },
    {
      path: "mobile-app-privacy-policy",
      component: AppPrivacyPolicyComponent,
      children: [
      ]
    },
    {
      path: "open-account",
      component: OpenAccountComponent,
      children: [
        
      ]
    },
    {
      path: "glossary",
      component: GlossaryComponent,
      children: [
        
      ]
    },
    {
      path: "disclosures",
      component: DisclosuresComponent,
      children: [
        
      ]
    },
    {
      path: "disclosures/history",
      component: HistoryComponent,
      // children: [
        
      // ]
    },
    {
      path: "disclosures/index-data",
      loadChildren:() => import('./pages/disclosures/index-descriptions/index-descriptions.module').then(m=>m.IndexDescriptionsModule)   
    },
    {
      path: "disclosures/index-data-2",
      loadComponent: () => import('./pages/disclosures/index-data-2/index-data-2.component').then(m => m.IndexData2Component)
    },
    {
      path: "disclosures/charts",
      component: SupChartsComponent,
      // children: [
        
      // ]
    },
    {
      path: "fees",
      component: FeesComponent,
      children: [
        
      ]
    },
    {
       path: "gallery",
       component: GalleryComponent
    },
    // {
    //   path: "gallery/architecture",
    //   component: ArchitectureComponent
    // },
    {
      path: "gallery/on-the-road",
      component: OnTheRoadComponent
    },
    {
      path: "resources",
      component: ResourcesComponent,
      children: [
        
      ]
    },
    {
      path: "survey",
      component: SurveyTemplateComponent,
      children: [

        {
          path: "",
          component: SurveyComponent,
        },

        {
          path: ":surveyId/profile",
          component: SurveyProfileComponent,
        },

        {
          path: ":surveyId/result",
          component: SurveyResultComponent,
        },
        {
          path: ":surveyId",
          component: SurveyComponent,
        },
        {
          path: ":surveyId/:questionNumber",
          component: SurveyComponent,
        }
        
      ]
    },
    {path: 'tools/survey', redirectTo: '/', pathMatch: 'full',},
    {
      path: "articles",
      component: ArticlesComponent,
      children: [
        {
          path: "",
          component: ArticleListComponent,
        },
        {
          path: ":friendlyUrl",
          component: ArticleDetailsComponent,
          children: [

          ]
        }
      ]
    },
    {
      path: "videos",
      component: VideosComponent,
      children: [
        {
          path: "",
          component: VideoListComponent,
        },
        {
          path: ":friendlyUrl",
          component: VideoDetailsComponent,
          children: [

          ]
        }
      ]
    },
  ]
  },
  {
      path: "**",
      component: PagesComponent,
      children: [{
        path: "**",
        component: ErrorComponent
      }]
  }
];


/**
 * The `AppRoutingModule` configures the application's main router.
 *
 * @remarks
 * This module sets up the Angular Router with custom options:
 * - `useHash: false`: Uses HTML5 pushState for navigation (no hash in URLs).
 * - `anchorScrolling: 'enabled'`: Enables automatic scrolling to anchor links.
 * - `scrollPositionRestoration: 'enabled'`: Restores scroll position on navigation.
 * - `scrollOffset: [0, 150]`: Offsets scroll position by 150px vertically.
 * - `canceledNavigationResolution: 'replace'`: Replaces the state when navigation is canceled.
 * - `paramsInheritanceStrategy: 'emptyOnly'`: Inherits route params only for empty paths.
 * - `urlUpdateStrategy: 'deferred'`: Updates the browser URL after navigation completes.
 *
 * @exports
 * Provides the configured `RouterModule` for use throughout the application.
 */
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    scrollOffset: [0, 150],
    canceledNavigationResolution: 'replace',
    paramsInheritanceStrategy: 'emptyOnly', //If you want the child routes of loadComponent routes to inherit data from their parent specify the paramsInheritanceStrategy to always, which in v17 is now set to emptyOnly.
    urlUpdateStrategy: 'deferred'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
